module.exports = __webpack_public_path__ + "static/media/done_v2.6d61f4cd.svg";